import { Provider } from '@angular/core';

import { EvaluationUseCasesImpl } from '@app/domain/use-cases/evaluation/evaluation.use-cases';
import { EVALUATION_USE_CASES } from '@app/domain/use-cases/evaluation/evaluation.use-cases.contract';

export const evaluationUseCasesProvider: Provider = {
  provide: EVALUATION_USE_CASES,
  useClass: EvaluationUseCasesImpl
};
